export const QUERY_TYPE = Object.freeze({
  QUERY: 'query',
  WORKFLOW: 'workflow',
  UPDATE: 'update',
  MERGE: 'merge',
  NEW_COLUMN: 'newColumn',
  REMOVE_ROWS: 'removeRows',
  AGGREGATE: 'aggregate'
})
